// extracted by mini-css-extract-plugin
export default {"-large":"fiGDoIRcjV49tAGd54eE","inputField":"b0o6_z3048eARIQuI8sc","bottomShadow":"nLl9h8XVN4CQ9CkAtCrj"};